var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#DAD8D4",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7499 7.875C18.2541 7.875 17.0416 9.08756 17.0416 10.5833C17.0416 10.7466 17.056 10.9065 17.0837 11.0618L13.1415 13.8213C13.1215 13.8353 13.1025 13.8503 13.0847 13.8662C12.6249 13.5062 12.0458 13.2917 11.4166 13.2917C9.92081 13.2917 8.70825 14.5042 8.70825 16C8.70825 17.4958 9.92081 18.7083 11.4166 18.7083C12.0458 18.7083 12.6249 18.4938 13.0847 18.1338C13.1025 18.1497 13.1215 18.1647 13.1415 18.1787L17.0837 20.9382C17.056 21.0935 17.0416 21.2534 17.0416 21.4167C17.0416 22.9124 18.2541 24.125 19.7499 24.125C21.2457 24.125 22.4583 22.9124 22.4583 21.4167C22.4583 19.9209 21.2457 18.7083 19.7499 18.7083C18.8726 18.7083 18.0927 19.1255 17.5978 19.7723L13.865 17.1593C14.0317 16.8079 14.1249 16.4148 14.1249 16C14.1249 15.5852 14.0317 15.1921 13.865 14.8407L17.5978 12.2277C18.0927 12.8745 18.8726 13.2917 19.7499 13.2917C21.2457 13.2917 22.4583 12.0791 22.4583 10.5833C22.4583 9.08756 21.2457 7.875 19.7499 7.875ZM18.2916 10.5833C18.2916 9.77792 18.9445 9.125 19.7499 9.125C20.5553 9.125 21.2083 9.77792 21.2083 10.5833C21.2083 11.3887 20.5553 12.0417 19.7499 12.0417C18.9445 12.0417 18.2916 11.3887 18.2916 10.5833ZM11.4166 14.5417C10.6112 14.5417 9.95825 15.1946 9.95825 16C9.95825 16.8054 10.6112 17.4583 11.4166 17.4583C12.222 17.4583 12.8749 16.8054 12.8749 16C12.8749 15.1946 12.222 14.5417 11.4166 14.5417ZM19.7499 19.9583C18.9445 19.9583 18.2916 20.6113 18.2916 21.4167C18.2916 22.2221 18.9445 22.875 19.7499 22.875C20.5553 22.875 21.2083 22.2221 21.2083 21.4167C21.2083 20.6113 20.5553 19.9583 19.7499 19.9583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBook);
export default __webpack_public_path__ + "static/media/share-book.b9d2fbeee43343fd4b9ce05846da9d35.svg";
export { ForwardRef as ReactComponent };